<template>
  <v-container>
    <v-fade-transition mode="out-in">
      <v-row v-if="!loading">
        <v-col cols="12">
          <div class="d-flex align-center flex-wrap">
            <h1>Ma liste d'associations</h1>
            <v-spacer />
            <v-btn data-testid="creer-association" outlined color="secondary" @click="versCreation">
              Créer une association
            </v-btn>
          </div>
        </v-col>
        <template v-if="sansAssociationsVisibles">
          <v-col cols="3"></v-col>
          <v-col cols="6">
            <p>Vous n'êtes rattaché à aucune association.</p>
            <p>
              Recherchez votre association dans le
              <router-link to="/association">registre</router-link> et effectuez une
              demande de rattachement à celle-ci.
            </p>
            <p>
              Vous devez d'abord vous rattacher à une association afin de pouvoir la
              gérer.
            </p>
          </v-col>
          <v-col cols="3"></v-col>
        </template>
        <template v-else>
          <v-col
            cols="12"
            lg="4"
            md="6"
            v-for="(a,index) in associationsVisibles"
            :key="numero(a)"
          >
            <a-association-dashboard-card
              :value="a"
              :validation="validation"
              @invitation="validationInvitation"
              :data-testid="`association-${index}`"
            />
          </v-col>
        </template>
      </v-row>
      <v-skeleton-loader v-else loading type="card-heading, actions, card, sentences" />
    </v-fade-transition>
  </v-container>
</template>

<script>
import { principalService, associationService } from "@/services";
import makeVuexSnackbar from "@/mixins/makeVuexSnackbar";

function compareBool(l, r) {
  if (!!l && !r) {
    return -1;
  } else if (!l && !!r) {
    return 1;
  }
  return 0;
}

export default {
  mixins: [makeVuexSnackbar()],
  data() {
    return {
      associations: [],
      loading: false,
      validation: false,
    };
  },

  mounted() {
    this.load();
  },

  computed: {
    sansAssociationsVisibles() {
      return !this.associationsVisibles.length;
    },
    associationsVisibles() {
      return [...this.associations].sort((l, r) => {
        var invitation = compareBool(l.invitation, r.invitation);
        var encours = compareBool(
          l.rattachement === "EN_COURS",
          r.rattachement === "EN_COURS"
        );
        const lRattachement = l.rattachement === "RATTACHE";
        var rattache = compareBool(lRattachement, r.rattachement === "RATTACHE");

        if (invitation !== 0) return invitation;
        if (rattache !== 0) return rattache;
        if (encours !== 0) return encours;

        const lNom = l.association.nom;
        const rNom = r.association.nom;

        return lNom.localeCompare(rNom);
      });
    },
  },

  methods: {
    numero(a) {
      return a.association?.numero;
    },
    versCreation() {
      this.$router.push({ path: "/creation" });
    },
    validationInvitation({ numero, valide }) {
      this.validation = true;
      associationService
        .valideInvitationAssociation(numero, valide)
        .then(resultat => {
          if (valide && !resultat) {
            this.snackbar({
              text: "Erreur durant le rattachement",
              subtext: "Rattachement impossible. Cette invitation n'existe plus.",
              color: "error",
            });
          }
          this.load();
        })
        .finally(() => (this.validation = false));
    },
    load() {
      this.loading = true;
      principalService
        .dashboardAssociations()
        .then(dashboard => {
          this.associations = dashboard.associations;
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
